<section class="hero-section">
  @if (isOpened) {
    <button class="music-control" (click)="toggleMusic()">
  @if (isPlaying) {
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#66332c" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z" />
    </svg>
  } @else {
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#66332c" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5V19L19 12L8 5Z" />
    </svg>
  }
</button>
  }

  <div class="envelope-wrapper" [class.open]="isOpened">
    <img src="assets/img/SOBRE1.png" class="env-part top-part" alt="Sobre arriba">
    <img src="assets/img/SOBREABAJJO.png" class="env-part bottom-part" alt="Sobre abajo">
    <div class="seal-container" (click)="openEnvelope()">
      <img src="assets/img/BOTONSOBRE.png" class="seal-icon" alt="Abrir">
    </div>
  </div>

  <div class="hero-wrapper">
    <img src="../../../assets/FONDOPRUEBA.jpg" class="hero-bg" alt="Fondo Invitación">
    <div class="hero-overlay">
      <div class="hero-header">
        <p class="wedding-text">NUESTRO CASAMIENTO</p>
        <p class="date-text">21.11.26</p>
      </div>
      <div class="names-box">
        <h1 class="hero-names">Lili & Oscar</h1>
      </div>
      <div class="arrow-container">
        <img src="assets/img/BOTON1.png" class="arrow-icon" alt="Bajar">
      </div>
    </div>
  </div>
</section>